import {Badge, Box, Image, Transition} from '@mantine/core';
import {useHover} from '@mantine/hooks';
import {growLeft, growRight} from '../utils/Transitions';

interface ExpandingButtonProps {
    active: boolean;
    onClick: () => void;
    icon: string;
    label: string
    expandDirection: 'LEFT' | 'RIGHT';
}

export function ExpandingButton({
    active,
    onClick,
    icon,
    label,
    expandDirection,
}: ExpandingButtonProps) {
    const {hovered, ref} = useHover<HTMLDivElement>();
    return (
        <Box
            onClick={onClick}
            title={label}
            ref={ref}
            style={{position: 'relative', zIndex: 100, cursor: 'pointer', pointerEvents: 'all'}}
            data-testid={`${label}-expanding-btn`}
        >
            <Image
                src={icon}
                w="3.5em" h="3.5em"
                bd='0.15em solid white'
                style={{borderRadius: '2em'}}
                alt={`${label} icon`} />
            <Transition
                mounted={hovered || active}
                transition={expandDirection === 'RIGHT' ? growRight : growLeft }
            >
                {(transitionStyle) => (
                    <Badge
                        style={{...transitionStyle, position: 'absolute', top: '20%', zIndex: -100}}
                        color="blue"
                        radius="lg"
                        size="xl"
                        variant="filled"
                        bd="0.15em solid white"
                        data-testid={`${label}-expanding-btn-label`}
                    >
                        {label}
                    </Badge>
                )}
            </Transition>
        </Box>
    );
}
